module.exports = __webpack_public_path__ + "img/coverfx2.80a4eb1f.jpg";